import { BuyStepsEnum } from "@/types/enums/StepsEnum";

export const handleStepChange = (
  direction: "up" | "down",
  currentStep: BuyStepsEnum,
  setStep: (step: BuyStepsEnum) => void,
  closeModal?: () => void
) => {
  const maxStep = BuyStepsEnum.FIVE;
  const minStep = BuyStepsEnum.ONE;
  if (direction === "up" && currentStep < maxStep) {
    setStep(currentStep + 1);
  } else if (direction === "down" && currentStep > minStep) {
    setStep(currentStep - 1);
  } else if (direction === "up" && currentStep === maxStep && closeModal) {
    closeModal(); // Close modal when reaching the last step
  } else if (direction === "down" && currentStep === minStep && closeModal) {
    closeModal(); // Close modal when reaching the first step
  }
};

export const getBuyButtonLabel = (currentStep: BuyStepsEnum): string => {
  switch (currentStep) {
    case BuyStepsEnum.ONE:
      return "Buy";
    case BuyStepsEnum.TWO:
      return "Buy";
    case BuyStepsEnum.FIVE:
      return "Done";
    case BuyStepsEnum.SIX:
      return "Done";
    default:
      return "Confirm";
  }
};

export const getBuyFromProfileButtonLabel = (currentStep: BuyStepsEnum): string => {
  switch (currentStep) {
    case BuyStepsEnum.ONE:
      return "Buy";
    case BuyStepsEnum.FIVE:
      return "Done";
    case BuyStepsEnum.SIX:
      return "Done";
    default:
      return "Confirm";
  }
};